import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconShare$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconShare extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e435939dd8282c50e34d6b969f9d22363ca36fcb', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'b4d03a2cf87c028e832f7311ba6337f2797ad071', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ef5d4f1e03bd5ddb1b7fee32e94f8df44f8285c4', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16 13.5a2.5 2.5 0 0 0-1.93.93l-5.61-3a3 3 0 0 0 0-.44q.015-.225 0-.45l5.62-3A2.49 2.49 0 1 0 13.5 6a1 1 0 0 0 0 .19l-5.76 3a2.5 2.5 0 1 0 0 3.54l5.76 3.06a1 1 0 0 0 0 .17A2.5 2.5 0 1 0 16 13.5", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-share", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-share"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-share":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconShare$1);
            }
            break;
    } });
}

const CosmosIconShare = CosmosIconShare$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconShare, defineCustomElement };
